module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      imageEditor: _vm.changed
    },
    attrs: {
      "id": "tuiImageEditor"
    }
  }, [(_vm.changed) ? _c('div', {
    staticClass: "imageEditorApp"
  }, [_c('image-editor-container')], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f83b920","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/EditorImageComponent.vue
// module id = 832
// module chunks = 1 3